module.exports = __webpack_public_path__ + "resources/img/main_banner_ngsc01.f86d37a0838fc54683ffaa361af1a79d.png";